import type { DiagnosisCodeInvalidReason } from '../services/api/types.gen';
import { diagnosisCodeValidityMessage } from '../utils/diagnosisCodeValidity';

/**
 * The inline warning for an invalid secondary diagnosis code.
 *
 * Styled like the principal-diagnosis fitness warning beside it, so both read
 * as the same kind of statement. Renders nothing for a valid code.
 */
export function DiagnosisCodeValidityWarning({
  reason,
  code,
}: {
  reason: DiagnosisCodeInvalidReason | null | undefined;
  /** Prefix the message with the code, for lists that do not sit on the row. */
  code?: string;
}) {
  const message = diagnosisCodeValidityMessage(reason);
  if (!message) return null;
  return (
    <p
      className='text-xs leading-snug text-destructive'
      data-testid='diagnosis-code-validity-warning'
    >
      {code ? (
        <span className='font-mono whitespace-nowrap'>{code}: </span>
      ) : null}
      {message}
    </p>
  );
}
